// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YBohi","colBig":"styles_colBig__1cFfv","colSmall":"styles_colSmall__1cYh9"};